export default __webpack_public_path__ + "static/media/user.f58d0f0d.svg";